import React from "react";

export default function PlanCard({
  plan,
  qty,
  inCart,
  onChangeQty,
  onAddPlan,
}) {
  return (
    <div className="plan-card-outer">
      {plan.isPopular && (
        <div className="ribbon-wrap">
          <div className="ribbon">Most Popular</div>
        </div>
      )}
      <div
        className={`plan-card${plan.isPopular ? " pop" : ""}${inCart ? " in-cart" : ""}`}
      >
      <div className={`card-bar ${plan.barClass}`} />

      <div className="card-body">
        {/* ── Plan image ── */}
        <div className="plan-img-wrap">
          <img
            src={plan.image}
            alt={plan.name}
            className="plan-img"
            loading="lazy"
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
        </div>

        <div className={`vbadge ${plan.vbadgeClass}`}>{plan.vbadgeText}</div>

        {/* ── Plan name split into main + sub ── */}
        <div className="card-name">{plan.name}</div>
        {plan.nameSub && (
          <div className="card-name-sub">{plan.nameSub}</div>
        )}
        <div className="card-desc">{plan.desc}</div>

        {/* ── Pricing ── */}
        <div className="card-price">
          <span className="cur">₹</span>
          {plan.price.toLocaleString("en-IN")}
          <span className="per">/yr</span>
        </div>

        {/* ── Feature list: icon · text · ✓/✕ ── */}
        <div className="feat-list">
          {plan.features.map((f, i) => (
            <div
              className={`feat-row${f.included ? " feat-yes" : " feat-no"}`}
              key={i}
            >
              <span className="feat-ico">{f.ico}</span>
              <span className="feat-text">{f.text}</span>
              <span className="feat-check">
                {f.included ? "✓" : "✕"}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="card-foot">
        <div className="qty-wrap">
          <button className="qb" onClick={() => onChangeQty(plan.id, -1)}>
            −
          </button>
          <div className="qv">{qty}</div>
          <button className="qb" onClick={() => onChangeQty(plan.id, 1)}>
            +
          </button>
        </div>
        <button
          className={`add-btn${inCart ? " active" : ""}`}
          onClick={() => onAddPlan(plan.id, plan.name, plan.price, plan.mrp, plan.sku, plan.nameSub || "")}
        >
          {inCart ? "Added ✓" : "Add to Cart"}
        </button>
      </div>
      </div>
    </div>
  );
}
